///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { CustomConfirmationAction, GtthConfirmationMessage, GtthNotificationMessage } from './gtth-notification-message';
import { _remove } from '../../../shared/utils';

@Injectable({
    providedIn: 'root'
})
export class GtthConfirmationService {
    messagesCounter = 0;
    private readonly maxStackLength = 1;
    confirmNotificationStack: GtthConfirmationMessage[];

    constructor() {
        this.confirmNotificationStack = [];
    }

    showWarningConfirmation(message: string, confirmActionText: string, declineActionText: string): Promise<boolean> {
        if (message && message !== '') {
            return this.showMessage(message, 'alert-warning', confirmActionText, declineActionText);
        }
    }

    showCustomConfigration(message: string, customActions: CustomConfirmationAction[]): void {
        this.showMessage(message, 'alert-warning', undefined, undefined, customActions);
    }

    clearAllMessages(): void {
        if (this.confirmNotificationStack) {
            this.confirmNotificationStack.forEach((message: GtthNotificationMessage) => {
                if (message) {
                    this.hideMessage(message.id);
                }
            });
        }

        this.confirmNotificationStack = [];
    }

    private showMessage(
        message: string,
        styleClass: string,
        confirmActionText: string,
        declineActionText: string,
        customActions?: CustomConfirmationAction[]
    ): Promise<boolean> {
        return new Promise<boolean>((resolve) => {
            if (!this.confirmNotificationStack) {
                resolve(false);
            } else {
                const messageId = this.messagesCounter;
                this.messagesCounter++;
                const confirmNotification = new GtthConfirmationMessage(
                    messageId,
                    message,
                    styleClass,
                    confirmActionText,
                    declineActionText
                );
                confirmNotification.customActions = customActions;

                if (this.confirmNotificationStack.length >= this.maxStackLength) {
                    this.hideMessage(this.confirmNotificationStack[0].id);
                }

                this.confirmNotificationStack.push(confirmNotification);

                confirmNotification.onConfirmResult = (userDecision: boolean) => {
                    this.hideMessage(messageId);
                    resolve(userDecision);
                };
            }
        });
    }

    private hideMessage(messageId: number): void {
        _remove(this.confirmNotificationStack, { id: messageId });

        if (this.confirmNotificationStack.length === 0) {
            this.messagesCounter = 0;
        }
    }
}
